export default "__VITE_ASSET__DZ2Bpl6N__"